module.exports = __webpack_public_path__ + "static/media/privacypolicy.09baa745.htm";